type Props = {
  children: React.ReactNode
  onClose?: () => void
}

export const Modal = (props: Props) => {
  return (
    <div className="fixed inset-0 z-10 overflow-y-auto" onClick={props.onClose}>
      <div className="flex min-h-screen items-center justify-center px-4 pb-20 pt-4 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-[rgba(0,0,0,0.3)]">{props.children}</div>
        </div>
      </div>
    </div>
  )
}
